import apiCommonCategory from "@/api/common-category";

export default class apiYrVipLog extends apiCommonCategory{
  static module = 'yr_vip_log'
}
